// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-body[data-v-192c23a1] {\n  gap: 2rem;\n  display: flex;\n  flex-direction: column;\n}\n.panel-body .panel-heading[data-v-192c23a1] {\n  cursor: pointer;\n}\n.panel-body .panel-heading[data-v-192c23a1]:hover {\n  background-color: #f5f5f5;\n}", ""]);
// Exports
module.exports = exports;
